<template>
  <div class="getLatLong" :class="colorTheme == 'blue' ? 'blueGetLatLong' : ''">
    <!--header-->
    <div class="header">
      <el-input placeholder="请输入内容" v-model="newAddress" @keyup.enter.native="doSearch">
        <template slot="append">
          <span @click="doSearch" class="doSearch">搜索</span>
        </template>
      </el-input>
    </div>
    <!--地图-->
    <div id="mapInDialong" ref="mapInDialong"></div>
    <!--右侧经纬度-->
    <div class="latLongWrappr">
      <div class="items">
        <div class="latLongItem">
          <div class="latLongItemTitle">经度</div>
          <el-input v-model="newLongitude" class="addressInput"></el-input>
        </div>
        <div class="latLongItem">
          <div class="latLongItemTitle">纬度</div>
          <el-input v-model="newLatitude" class="addressInput"></el-input>
        </div>
      </div>
      <!--确定-->
      <div class="btnWrapper">
        <el-button type="primary" :class="colorTheme == 'blue' ? 'btn-blue' : ''" @click="makeSure">确定经纬度</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const qq = window.qq
export default {
  props: {
    colorTheme: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    longitude: {
      type: String,
      default: ''
    },
    latitude: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newAddress: this.address, // 地址
      newLongitude: this.longitude, // 经度
      newLatitude: this.latitude, // 纬度
      geocoder: null, // 根据地址获取经纬度
      map: null, // 地图
      marker: null, // 标记
      info: null, // 移动窗体
      pointTrans: null // 解析之后的经纬度对象
    }
  },
  created() {
    // 初始化地图
    // this.initMap();
    this.$nextTick(() => {
      this.isHaveLatLong()
    })
  },
  methods: {
    // 组件初始化状态判断
    isHaveLatLong() {
      if (!this.newLatitude && !this.newLongitude) {
        // 不存在经纬度时
        // 判断地址是否存在 如果不存在设置地址默认为合肥
        this.newAddress = this.newAddress ? this.newAddress : '安徽省合肥市'
        // 根据当前地址解析经纬度 pointer为解析到的经纬度
        this.addrTransformation(
          pointer => {
            // 设置经纬度初始值
            this.newLongitude = pointer.lng
            this.newLatitude = pointer.lat
            // 初始化地图
            this.initMap(pointer)
          },
          () => {
            this.newLongitude = '117.30794'
            this.newLatitude = '31.79322'
            let defaultPoint = new qq.maps.LatLng(this.newLatitude, this.newLongitude)
            // 初始化地图
            this.initMap(defaultPoint)
          }
        )
      } else {
        // 存在经纬度
        let pointer = new qq.maps.LatLng(this.newLatitude, this.newLongitude)
        // 初始化地图
        this.initMap(pointer)
      }
    },
    // 地址解析（新）
    addrTransformation(sCallBack) {
      let searchService = new qq.maps.SearchService({
        complete: results => {
          if (results.type === 'CITY_LIST') {
            this.$message.error('请输入城市再进行搜索哦~')
          }
          if (results.type === 'POI_LIST') {
            sCallBack(results.detail.pois[0].latLng)
          }
        }
      })
      searchService.search(this.newAddress)
    },
    // 地址逆解析
    getAddr(latLng) {
      this.geocoderNo = new qq.maps.Geocoder()
      const coord = new qq.maps.LatLng(latLng.lat, latLng.lng)
      this.geocoderNo.getAddress(coord)
      // 设置服务请求成功的回调函数
      this.geocoderNo.setComplete(result => {
        let data = result.detail.addressComponents
        this.newAddress =
          data.province + data.city + data.district + data.town + data.street + data.streetNumber
      })
      // 若服务请求失败，则运行以下函数
      this.geocoderNo.setError(function() {
        alert('出错了，请输入正确的经纬度！！！')
      })
    },
    // 地图初始化
    initMap(pointer) {
      this.map = new qq.maps.Map(this.$refs.mapInDialong, {
        center: pointer,
        zoom: 12
      })
      // 创建标记
      this.marker = new qq.maps.Marker({
        map: this.map,
        position: pointer,
        draggable: true,
        animation: qq.maps.MarkerAnimation.DROP
      })
      // 创建窗体,添加信息窗口
      this.info = new qq.maps.InfoWindow({
        map: this.map
      })
      // 获取标记的可拖动属性
      this.info.open()
      this.info.setContent('拖动改变位置')
      this.info.setPosition(pointer)

      // 标记Marker点击事件
      qq.maps.event.addListener(this.map, 'click', event => {
        this.info.open()
        this.info.setContent('拖动改变位置')
        this.info.setPosition(event.latLng)
        // 获取当前点击的经纬度
        let data = event.latLng
        this.marker.setPosition(data)
        this.newLongitude = data.lng
        this.newLatitude = data.lat
        // 地址逆解析
        let latLng = new qq.maps.LatLng(data.lat, data.lng)
        this.getAddr(latLng)
      })
      // 设置Marker停止拖动事件
      qq.maps.event.addListener(this.marker, 'dragend', () => {
        this.info.open()
        this.info.setContent('拖动改变位置')
        // getPosition()  返回Marker的位置
        this.info.setPosition(this.marker.getPosition())
        let data = this.marker.getPosition()
        this.newLongitude = data.lng
        this.newLatitude = data.lat
        // 地址逆解析
        let latLng = new qq.maps.LatLng(data.lat, data.lng)
        this.getAddr(latLng)
      })
    },
    // 执行搜索
    doSearch() {
      this.addrTransformation(pointer => {
        // 设置经纬度初始值
        this.newLongitude = pointer.lng
        this.newLatitude = pointer.lat
        // 初始化marker
        this.marker.setPosition(pointer)
        this.info.setPosition(pointer)
        // 初始化地图中心
        this.map.setCenter(pointer)
      })
    },
    // 确认提交经纬度
    makeSure() {
      let val = {
        lat: this.newLatitude,
        lng: this.newLongitude,
        street: this.newAddress
      }
      this.$emit('getLatLong', val)
    }
  }
}
</script>
<style>
.blueGetLatLong .el-input__inner:focus{
  border-color: rgba(63, 154, 255, 0.6)!important;
}
</style>
<style lang="scss" scoped>
.getLatLong {
  .header {
    display: flex;
    align-items: center;
    .doSearch {
      cursor: pointer;
    }
  }
  #mapInDialong {
    height: 400px;
    margin-top: 20px;
  }
  .latLongWrappr {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .items {
      display: flex;
      .latLongItem {
        display: flex;
        align-items: center;
        .latLongItemTitle {
          width: 50px;
        }
        &:first-child {
          margin-right: 40px;
        }
      }
    }
  }
  .btnWrapper {
    text-align: center;
    .btn-blue {
      background-color: #3F9AFF;
      border-color: #3F9AFF;
    }
  }
}
</style>